import React from 'react';
import clsx from 'clsx';

interface FormSkeletonProps {
  sections?: number;
  fieldsPerSection?: number;
  columns?: number;
}

const FormSkeleton: React.FC<FormSkeletonProps> = ({
  sections = 2,
  fieldsPerSection = 3,
  columns = 2,
}) => {
  return (
    <div className="flex flex-col h-full bg-white dark:bg-gray-900">
      {/* Header Skeleton */}
      <div className="px-6 pt-6 pb-4 border-b border-gray-200 dark:border-gray-700">
        <div className="space-y-2">
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/3 animate-fadePulse" />
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2 animate-fadePulse" />
        </div>
      </div>

      {/* Form Content Skeleton */}
      <div className="flex-1 overflow-y-auto custom-scrollbar-main">
        <div className="mx-auto w-full max-w-3xl px-6 py-6 space-y-8">
        {Array.from({ length: sections }).map((_, sectionIdx) => (
          <div key={sectionIdx}>
            {/* Section Header */}
            <div className="mb-4 space-y-1">
              <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-1/4 animate-fadePulse" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3 animate-fadePulse" />
            </div>

            {/* Fields Grid */}
            <div
              className="grid gap-4"
              style={{
                gridTemplateColumns:
                  columns === 1
                    ? '1fr'
                    : columns === 2
                      ? 'repeat(2, 1fr)'
                      : 'repeat(3, 1fr)',
              }}
            >
              {Array.from({ length: fieldsPerSection }).map((_, fieldIdx) => (
                <div
                  key={fieldIdx}
                  className="space-y-2"
                >
                  {/* Label */}
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3 animate-fadePulse" />
                  {/* Input Field */}
                  <div className="h-10 bg-gray-100 dark:bg-gray-800 rounded border border-gray-200 dark:border-gray-700 animate-fadePulse" />
                </div>
              ))}
            </div>
          </div>
        ))}
        </div>
      </div>

      {/* Footer Skeleton */}
      <div className="border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 px-6 py-4">
        <div className="mx-auto w-full max-w-3xl flex justify-end gap-3">
          <div className="h-9 bg-gray-300 dark:bg-gray-600 rounded w-24 animate-fadePulse" />
          <div className="h-9 bg-gray-300 dark:bg-gray-600 rounded w-24 animate-fadePulse" />
        </div>
      </div>
    </div>
  );
};

export default FormSkeleton;
